import useAppStore from '@/stores/app';
import useViewStore from '@/stores/view';
import { lxFlowUtils } from '@dativa-lv/lx-ui';

// This portal is fully anonymous (gated only by an upload-link token), so the
// guards just drive the shell's navigating/loading state — there is no auth.
export default (router) => {
  router.beforeEach((to, from, next) => {
    const appStore = useAppStore();
    if (appStore?.$state) appStore.$state.isNavigating = true;
    next();
  });

  router.afterEach(async (to, from) => {
    const appStore = useAppStore();
    const viewStore = useViewStore();
    viewStore.$reset();
    await lxFlowUtils.afterEach(to, from, appStore);
    lxFlowUtils.removeFocus();
  });
};
